// extracted by mini-css-extract-plugin
export default {"grid":"Ministries_grid__uSk10"};